<div class="card">
  <p class="text-xl font-bold">Avaliações</p>
  <div>
    <p>Valide cada documento enviado.</p>
    <p>
      Marque como Aprovado ou Reprovado. Justifique reprovações no campo de
      observações.
    </p>
  </div>
  <form [formGroup]="rulesForm" class="mt-5">
    <div formArrayName="rules" class="space-y-2">
      <div
        class="flex flex-wrap justify-between items-center rounded-lg bg-gray-100 p-2"
      >
        <p>
          Avaliações concluídas: {{ totalRules() }} de
          {{ totalAnsweredRules() }}
        </p>
        @if (isAssessmentCompleted()) {
          <div class="flex gap-2 items-center">
            <p class="font-bold text-nowrap">Resultado Final:</p>
            <app-tag-status
              [status]="assessmentStatusTag"
              [text]="assessmentStatusDescription()"
            ></app-tag-status>
            <p-button
              type="button"
              icon="ph ph-eye"
              [rounded]="true"
              [outlined]="true"
              (click)="openSaveAssessmentDialog()"
            />
          </div>
        } @else {
          @if (canAvaluateOrder()) {
            <p-button
              label="Revisar e Confirmar"
              rounded
              class="text-nowrap"
              [disabled]="!allRulesValuated()"
              (click)="openSaveAssessmentDialog()"
            ></p-button>
          }
        }
      </div>
      @for (item of assessmentRules(); track item.id; let i = $index) {
        <div
          class="flex justify-between items-center py-2 bg-gray-100 rounded-lg p-2"
          [formGroupName]="i"
        >
          <p class="font-bold text-wrap">
            {{ item.assessmentRuleName }}
          </p>

          @if (canAvaluateOrder()) {
            <div>
              @if (isRulePeddingAnswer(item)) {
                <p-button
                  type="button"
                  label="Avaliar"
                  rounded
                  (click)="openRuleDecisionDialog($index)"
                />
              } @else {
                <div class="flex items-center gap-2">
                  <div>
                    <app-tag-status
                      [status]="getRuleStatusTag(item.status)"
                      [text]="getRuleStatusDescription(item.status)"
                      class="block"
                    ></app-tag-status>
                  </div>
                  <p-button
                    type="button"
                    icon="ph ph-pencil"
                    [rounded]="true"
                    [outlined]="true"
                    (click)="openRuleDecisionDialog($index)"
                    [class.hidden]="isAssessmentCompleted()"
                  />
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </form>
</div>

<p-dialog
  [(visible)]="ruleDialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '32rem' }"
  header="Nota de análise"
>
  <form
    [formGroup]="ruleDialogForm"
    class="rounded-2xl bg-gray-200 p-5 space-y-5"
  >
    <div>
      <label for="decision" class="font-bold"> Avaliação </label>
      <p class="text-lg text-primary font-bold">{{ selectedRuleName }}</p>
    </div>
    <div>
      <label for="decision" class="font-bold">
        Selecione o seu veredito:
      </label>
      <div class="flex gap-2 mt-2">
        <div class="flex items-center gap-2">
          <p-radioButton
            name="decision"
            formControlName="decision"
            [value]="RuleStatus.Approved"
            inputId="decisionApproved"
          />
          <label for="decisionApproved" class="cursor-pointer"> Aprovar </label>
        </div>

        <div class="flex items-center gap-2">
          <p-radioButton
            name="decision"
            formControlName="decision"
            [value]="RuleStatus.Rejected"
            inputId="decisionRejected"
          />
          <label for="decisionRejected" class="cursor-pointer">
            Reprovar
          </label>
        </div>
      </div>
    </div>

    <div>
      <label for="note" class="font-bold">Observações</label>
      <textarea
        pInputTextarea
        rows="4"
        class="w-full"
        placeholder="Caso haja, escreva algum diferencial sobre essa análise"
        formControlName="note"
      ></textarea>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        label="Fechar"
        severity="secondary"
        rounded
        class="btn-secondary-outline"
        (click)="closeRuleDecisionDialog()"
      >
      </p-button>
      <p-button
        label="Confirmar e Salvar"
        (click)="confirmRuleDecision()"
        [disabled]="ruleDialogForm.invalid"
        [loading]="loading()"
        rounded
      />
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="saveAssessmentDialogVisible"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '35rem' }"
  header="Decisão Final do Pedido"
>
  <form
    [formGroup]="assessmentDialogForm"
    class="rounded-2xl bg-gray-200 p-5 space-y-5"
  >
    <div class="flex justify-between items-center">
      <div>
        <label class="font-bold">Cliente</label>
        <p class="text-lg font-bold text-primary">{{ customerName() }}</p>
      </div>
      <div>
        <p class="font-bold">Resultado Final</p>
        @if (totalNonApprovedRules() == 0) {
          <app-tag-status
            [status]="'Approved'"
            [text]="'Aprovado'"
            class="block mt-1"
          ></app-tag-status>
        } @else {
          <app-tag-status
            [status]="'Rejected'"
            [text]="'Reprovado'"
            class="block mt-1"
          ></app-tag-status>
        }
      </div>
    </div>

    <div class="card">
      <div class="flex justify-between items-center">
        <p class="font-bold">Análise</p>
        <div class="flex gap-2 mt-1">
          @if (totalNonApprovedRules() === 0) {
            <span class="font-bold text-primary">100%</span>
          } @else {
            <span class="font-bold text-red-700">
              {{ ((totalNonApprovedRules() / totalRules()) * 100).toFixed(0) }}%
            </span>
          }
          <p>
            {{
              totalNonApprovedRules() == 0
                ? totalRules()
                : totalNonApprovedRules()
            }}
            de {{ totalRules() }}
          </p>
        </div>
      </div>
      <hr class="mb-0!" />
      <p-accordion value="0" class="assessment-rules">
        <p-accordion-panel value="0">
          <p-accordion-header>
            <p class="font-bold">Observações</p>
          </p-accordion-header>
          <p-accordion-content>
            <div class="space-y-5">
              @for (item of assessmentRules(); track item.id; let i = $index) {
                <div>
                  <div class="flex gap-2">
                    @if (item.status === RuleStatus.Approved) {
                      <span
                        class="ph-duotone ph-check-circle text-xl text-green-light"
                      ></span>
                    } @else {
                      <span
                        class="ph-duotone ph-x-circle text-red-700 text-xl"
                      ></span>
                    }
                    <p class="font-bold">{{ item.assessmentRuleName }}</p>
                  </div>
                  <p class="text-sm">{{ item.note }}</p>
                </div>
                @if (!$last) {
                  <hr />
                }
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>

    @if (!isAssessmentCompleted()) {
      <div class="mt-5">
        <label class="font-bold">Justificativa</label>
        <textarea
          pInputTextarea
          rows="4"
          class="w-full"
          placeholder="Descreva os motivos que fundamentaram sua decisão."
          formControlName="note"
        ></textarea>
      </div>
    }
    @if (!isAssessmentCompleted() && approvalBlockReasons().length > 0) {
      <div class="rounded-lg border border-red-300 bg-red-50 p-4 text-red-700">
        <div class="flex items-center gap-2">
          <span class="ph-duotone ph-warning-circle text-xl"></span>
          <p class="font-bold">O pedido não pode ser aprovado</p>
        </div>
        <ul class="mt-2 list-disc pl-6 text-sm space-y-1">
          @for (reason of approvalBlockReasons(); track reason) {
            <li>{{ reason }}</li>
          }
        </ul>
        <p class="mt-2 text-sm">
          Sem esses cadastros o contrato e as parcelas não podem ser gerados para o cliente. Realize os cadastros para seguir com a aprovação do pedido.
        </p>
      </div>
    }
    @if (isAssessmentCompleted() && assessmentFormNoteValue) {
      <div class="flex flex-col">
        <label class="font-bold">Justificativa</label>
        {{ assessmentFormNoteValue }}
      </div>
    }
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        label="Fechar"
        severity="secondary"
        rounded
        class="btn-secondary-outline"
        (click)="cancelSaveAssessment()"
      >
      </p-button>
      @if (!isAssessmentCompleted()) {
        <p-button
          label="Confirmar e Salvar"
          (click)="saveAssessment()"
          [disabled]="approvalBlockReasons().length > 0"
          [loading]="loading()"
          rounded
        />
      }
    </div>
  </ng-template>
</p-dialog>
